import { LoadingRegion } from "./loading-region";
import { SkeletonLine, SkeletonAvatarSm, SkeletonBlock } from "./skeleton-primitives";

function ArchiveRowSkeleton() {
  return (
    <tr className="border-b border-border/30">
      <td className="px-5 py-3.5">
        <div className="flex gap-2.5">
          <SkeletonAvatarSm className="size-8" />
          <div className="min-w-0 flex-1 space-y-2">
            <SkeletonLine className="h-4 w-40" />
            <SkeletonLine className="h-3 w-24" />
          </div>
        </div>
      </td>
      <td className="px-5 py-3.5">
        <SkeletonLine className="h-4 w-20" />
      </td>
      <td className="px-5 py-3.5">
        <SkeletonLine className="h-4 w-28" />
      </td>
      <td className="px-5 py-3.5">
        <SkeletonLine className="h-4 w-24" />
      </td>
      <td className="px-5 py-3.5 text-right">
        <SkeletonBlock className="ml-auto h-8 w-20 rounded-lg" />
      </td>
    </tr>
  );
}

export function ArchiveTableSkeleton() {
  return (
    <LoadingRegion busy labelKey="common.loadingTable" className="w-full">
      <div className="max-h-[calc(100dvh-13rem)] overflow-hidden">
        <table className="w-full min-w-[640px]">
          <thead>
            <tr className="border-b border-border/50 bg-muted/30">
              {Array.from({ length: 5 }).map((_, i) => (
                <th key={i} className="px-5 py-3 text-left">
                  <SkeletonLine className="h-3 w-20" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 8 }).map((_, i) => (
              <ArchiveRowSkeleton key={i} />
            ))}
          </tbody>
        </table>
      </div>
    </LoadingRegion>
  );
}
